import { Pipe, PipeTransform } from '@angular/core';


export class RoundNumberPipe implements PipeTransform {
	public transform(value: any, args?: any[]): string {
		if (args) {
			/**
			 * remove first argument support OR change implementation as the Math.round works up/down depending on number
			 */
			let roundType: String = 'up';
			if (typeof args[0] !== undefined) {
				roundType = args[0];
			}

			let roundDecimalsNumber = 2;
			if (typeof args[1] !== undefined) {
				roundDecimalsNumber = args[1];
			}

			let divideNumber = Math.pow(10, roundDecimalsNumber);

			if (roundType === 'up') {
				return String(Math.round(value * divideNumber) / divideNumber);
			}
		}
		return '';
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/pipes/round-number.pipe.ts